if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Product Addons
        let addons = [];
        const groupId = Math.floor(Math.random() * 100000);

        const addonProducts = document.querySelectorAll('.complementary-product.complementary-product--addons');
        addonProducts.forEach(prod => {
          const productCheckbox = prod.querySelector('.complementary-product_check input');
          const productTitle = prod.getAttribute('data-addon-title');
          const productHasDefaultVariant = prod.getAttribute('data-has-default-variant');
          let variantId;
          let productPrice;
          if(productCheckbox.checked) {
            if (productHasDefaultVariant === "true") {
              variantId = productCheckbox.value;
              productPrice = prod.getAttribute('data-addon-price');
            } else {
              const selectedOption = prod.querySelector('.complementary-product--variants select');
              variantId = selectedOption.options[selectedOption.selectedIndex].value;
              productPrice = selectedOption.options[selectedOption.selectedIndex].getAttribute('data-price');
            }
            addons.push({
              id: variantId,
              title: productTitle,
              price: productPrice,
              quantity: 1,
              properties: {
                _addon_for: formData.get('id')
              }
            })
          }
        });

        if (addons.length > 0) {
          formData.append('properties[_has_addon]', "true");
          formData.append('properties[_group_id]', groupId);
          formData.append('properties[_group_contents]', JSON.stringify(addons.map(addon => addon.title)));
          formData.append('properties[_group_total_pricing]', addons.reduce((total, addon) => total + parseFloat(addon.price || 0), 0));
        }

        // Append addons to form
        addons.forEach((addon, index) => {
          formData.append(`items[${index}][id]`, addon.id);
          formData.append(`items[${index}][quantity]`, addon.quantity);
          formData.append(`items[${index}][properties][_group_id]`, groupId);
          formData.append(`items[${index}][properties][_addon_for]`, addon.properties._addon_for);
        });

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
